import { useEffect, useState } from 'react';
import './GigList.scss';
import { FetchData } from '../../utils/FetchData'

export function GigList () {
    const [list, setList] = useState<Array<any>>([]);

    const fetchGigList = () => {
        FetchData('gigs/list').
         then((data) =>
            setList(data.response.gigs)
         ).catch((e) => console.error(e));
    }
  
    useEffect(() => {
        fetchGigList();
    }, []);

    return (
        <>
        { list.length > 0 && <div className="gig-list">
                <h2><i className="fas fa-calendar-alt"></i> Próximos conciertos</h2>
                <ul>
                    { list.map((gig, index) => (
                        <li key={index}>
                            <h4>{gig.date}</h4>
                            <h3>{gig.title}</h3>    
                            { gig.place && <address>{gig.place} <a href={`https://www.google.es/maps?q=${gig.place}`} title="ver en Google Maps" target='_blank'><i className="fas fa-map-marker-alt"></i></a> </address> }
                        </li>
                    ))}
                </ul>
            </div>}
        </>
    );

}